import { formatCompact } from '@bonanza-social/toolkit/utils';
import { StatusPerkRewardType } from '../../../state';

export const formatPerkRewardAmount = (
  rewardAmount: number,
  rewardType: StatusPerkRewardType,
) => {
  switch (rewardType) {
    case 'Coins':
      return formatCompact(rewardAmount);
    case 'Percentage':
      return `${rewardAmount}%`;
    case 'Multiplier':
      return `${rewardAmount}X`;
    default:
      return rewardAmount;
  }
};
